<template>
	<Modal
		@dismiss="dismiss"
		:custom_style="{ width: currentTab === 'link' ? '524px' : '1192px', height: currentTab === 'link' ? '208px' : '736px' }"
	>
		<header class="header-modal">
			<nav class="tab-container radio-group-2">
				<input
					id="linkTab"
					type="radio"
					name="linkTab"
					:checked="currentTab === 'link'"
					@input="setTab(tabs.LINK)"
				/>
				<label for="linkTab" class="radio-label light">
					<span>By URL</span>
				</label>
				<input
					id="gifTab"
					type="radio"
					name="gifTab"
					:checked="currentTab === 'gif'"
					@input="setTab(tabs.GIF)"
				/>
				<label for="gifTab" class="radio-label light">
					<span>GIPHY</span>
				</label>
			</nav>
			<button type="button" class="button-icon light button-close" @click="dismiss">
				<img src="../../assets/img/icons/round-close-24px.svg" />
			</button>
		</header>
		<main>
			<section v-if="currentTab === 'link'" id="linkSection">
				<input v-model="imageURL" type="text" placeholder="Paste image URL here" />
				<button
					type="button"
					class="button primary mt-16"
					@click="addImage"
					:disabled="imageURL.length === 0"
				>Add image</button>
			</section>
			<section v-if="currentTab === 'gif'" id="gifSection">
				<div id="gifSearchContainer">
					<div class="search-container">
						<input
							v-model="gifSearchString"
							type="search"
							placeholder="Search for a GIF"
							@input="loadGIFs(search_delay)"
							@keyup.enter="loadGIFs()"
						/>
					</div>
				</div>
				<div id="imGifContainer">
					<div v-if="gifs.length > 0" id="imGifList">
						<img
							v-for="(gif, ii) in gifs"
							class="im-gif"
							:key="gif.id + '-' + ii"
							:style="{
									'background-image': `url(${gif.fixed_height.url})`,
									'width': `${gif.fixed_height.width}px`,
									'height': `${gif.fixed_height.height}px`
								}"
							@click="selectGIF(gif)"
						/>
					</div>
					<div v-else-if="loading">Loading...</div>
					<div v-else>No GIFs found.</div>
					<button
						v-if="gifs.length > 0"
						type="button"
						class="button primary mt-16"
						@click="loadMoreGIFs"
						:disabled="loading"
					>Load more</button>
				</div>
			</section>
		</main>
	</Modal>
</template>

<script>
import Modal from "./modal";

export default {
	data() {
		return {
			tabs: {
				LINK: "link",
				GIF: "gif"
			},
			currentTab: "link",
			imageURL: "",
			gifStillURL: null,
			gifSearchString: "",
			gifs: [],
			search_timeout: null,
			search_delay: 1000,
			loading: false,
			gif_load_limit: 12,
			currentGifPage: 0
		};
	},
	components: {
		Modal
	},
	watch: {
		currentTab(value) {
			if (value === "gif" && this.gifs.length === 0) this.loadGIFs();
		}
	},
	methods: {
		dismiss() {
			this.$emit("input", { success: false });
		},
		addImage() {
			this.$emit("input", {
				success: true,
				image_url: this.imageURL,
				still_url: this.gifStillURL
			});
		},
		selectGIF(gifObj) {
			this.imageURL = gifObj.original.url;
			this.gifStillURL = gifObj.still.url;
			this.addImage();
		},
		setTab(tab) {
			this.currentTab = tab;
		},
		loadMoreGIFs() {
			this.loadGIFs(null, ++this.currentGifPage);
		},
		async loadGIFs(delay, page) {
			if (!page) this.currentGifPage = 0;
			clearTimeout(this.search_timeout);

			// delay load if delay parameter is present
			if (delay) this.search_timeout = setTimeout(this.loadGIFs, delay);
			// load using search string if it exists
			else if (this.gifSearchString.length > 0) {
				this.loading = true;
				if (this.currentGifPage === 0) this.gifs = [];
				let offset = this.gif_load_limit * this.currentGifPage;

				const response = await this.$http({
					method: "get",
					url: `https://api.giphy.com/v1/gifs/search?api_key=sGbbLnIwXsjKWmuA3JlXOqCzvGQ2HriO&limit=${this.gif_load_limit}&rating=R&q=${this.gifSearchString}&offset=${offset}`
				});
				// concatenate with previous GIFs in case loading next page
				this.gifs = this.gifs.concat(
					response.data.data.map(gif => {
						return {
							id: gif.id,
							fixed_height: gif.images.fixed_height,
							original: gif.images.original,
							still: gif.images.original_still
						};
					})
				);

				this.loading = false;
				// load trending GIFs if search string does not exist
			} else {
				this.loading = true;
				if (this.currentGifPage === 0) this.gifs = [];
				let offset = this.gif_load_limit * this.currentGifPage;

				const response = await this.$http({
					method: "get",
					url: `https://api.giphy.com/v1/gifs/trending?api_key=sGbbLnIwXsjKWmuA3JlXOqCzvGQ2HriO&limit=${this.gif_load_limit}&rating=R&offset=${offset}`
				});

				this.gifs = this.gifs.concat(
					response.data.data.map(gif => {
						return {
							id: gif.id,
							fixed_height: gif.images.fixed_height,
							original: gif.images.original,
							still: gif.images.original_still
						};
					})
				);

				this.loading = false;
			}
		}
	},
	beforeDestroy() {
		this.gifs = [];
		clearTimeout(this.search_timeout);
	}
};
</script>

<style scoped>
.header-modal {
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	box-shadow: none;
	padding-top: 16px;
	/* margin-bottom: 24px; */
}

#imGifContainer {
	position: relative;
	padding: 0 20px 24px 20px;
	margin-top: 24px;
}

#imGifList {
	display: flex;
	flex-wrap: wrap;
}

#gifSearchContainer,
#linkSection {
	width: 460px;
	margin: auto;
}

#linkSection,
#gifSection {
	margin-top: 24px;
}

#linkSection .button,
#imGifContainer .button {
	margin-left: auto;
	margin-right: auto;
}

.tab-container {
	width: 162px;
}

.im-gif {
	margin: 4px;
	transition: transform 0.1s ease;
	border-radius: 4px;
	flex: 1 0 auto;
	background-color: var(--light-gray);
	background-repeat: no-repeat;
	background-position: center;
	background-size: cover;
}
.im-gif:hover {
	transform: scale(1.03);
}
</style>
